import { defineStore } from 'pinia'
import type { RoleCode } from '@prisma/client'

interface RoleState {
  roleCode: RoleCode | null
  roleName: string | null
  roleId: string | null
  loading: boolean
}

interface UserResponse {
  success: boolean
  data?: {
    id: string
    name: string
    code: RoleCode
  }
}

export const useRoleStore = defineStore('role-store', {
  state: (): RoleState => ({
    roleCode: null,
    roleName: null,
    roleId: null,
    loading: false,
  }),

  actions: {
    setRole(payload: { roleCode: RoleCode, roleName: string, roleId: string }) {
      console.log(`[Role Store] Setting role: ${payload.roleCode}, ${payload.roleName}`)
      this.roleCode = payload.roleCode
      this.roleName = payload.roleName
      this.roleId = payload.roleId
    },

    clearRole() {
      console.log('[Role Store] Clearing role')
      this.roleCode = null
      this.roleName = null
      this.roleId = null
    },

    async fetchUserRole() {
      console.log('[Role Store] Starting fetchUserRole()')

      // Check if we're on the server
      if (import.meta.server) {
        console.log('[Role Store] Skipping role fetch on server')
        return
      }

      try {
        this.$state = { ...this.$state, loading: true }
        console.log('[Role Store] Fetching from /api/v1/users/me...')

        // Get current user role from API
        const response = await $fetch<UserResponse>('/api/v1/users/me')
        console.log('[Role Store] API response:', response)

        if (response.success && response.data) {
          console.log('[Role Store] Setting role:', response.data)
          this.setRole({
            roleCode: response.data?.role?.code,
            roleName: response.data?.role?.name,
            roleId: response.data?.role?.id,
          })
          console.log('[Role Store] Role set:', this.roleCode)
        }
        else {
          console.warn('[Role Store] No role data returned from API')
          this.clearRole()
        }
      }
      catch (error) {
        console.error('[Role Store] Failed to fetch user role:', error)
        this.clearRole()
      }
      finally {
        this.$state = { ...this.$state, loading: false }
        console.log(`[Role Store] Fetch complete, current role: ${this.roleCode || 'none'}`)
      }
    },
  },
  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
  },

})
